import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BusinessProfilesHttpService } from '../../../../../services/http-services/business-profiles/business-profiles-http.service';
import { DatePipe } from '@angular/common';
import { DaysOfWeek } from '../../../../../constants/general-variables';

@Component({
  selector: 'gr-change-work-terms-modal',
  templateUrl: './change-work-terms-modal.component.html',
})
export class ChangeWorkTermsModalComponent implements OnInit {
  workingDateForm!: FormGroup;
  initialWorkState = false;
  dayOfWeek!: number;
  @Input() urlParams: any;
  @Input() selectedTermsDate: any = null;
  @Input() selectedDateKey: any;
  @Input() selectedDayName: any;
  @Input() newSlotsSelectedDateKey: any = null;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();
  protected readonly DaysOfWeek = DaysOfWeek;
  isShowTimeslot: any = false;
  selectedSlot: any | null;
  isSlotSelected = false;

  constructor(private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private businessProfilesHttpService: BusinessProfilesHttpService) {
  }

  ngOnInit(): void {
    const date = new Date(this.selectedTermsDate[0].start);
    this.dayOfWeek = date.getUTCDay() ? date.getUTCDay() - 1 : date.getUTCDay();
    this.initialWorkState = !!this.selectedTermsDate[0].work;
    this.buildForm();
  }

  buildForm(): void {
    this.workingDateForm = this.formBuilder.group({
      day: ['', Validators.required],
      work: [false],
    });
    this.workingDateForm.controls.day.patchValue(this.newSlotsSelectedDateKey !== null ? this.newSlotsSelectedDateKey : this.datePipe.transform(this.selectedTermsDate[0].start, 'yyyy-MM-dd'));
    this.workingDateForm.controls.work.patchValue(!!this.selectedTermsDate[0].work);
  }

  onSubmit(): void {
    if (this.newSlotsSelectedDateKey !== null) {
      this.onSubmitFormForNewSlots();
    } else {
      this.onSubmitForm();
    }
  }

  onSubmitForm(): void {
    this.businessProfilesHttpService.postToggleWorkingDate(this.urlParams, this.workingDateForm.value).then(res => {
      this.confirmModal.emit();
    });
  }

  onSubmitFormForNewSlots(): void {
    const izabraniDanAlt = this.workingDateForm.value.day;
    const payload = {
      date: izabraniDanAlt
    }
    this.businessProfilesHttpService.postToggleWorkingDateSlot(this.urlParams, payload).then(res => {
      this.confirmModal.emit();
    });
  }

  showTimeslots(term: any): void {
    this.isShowTimeslot = term;
    console.log('selectedtimeslot', this.isShowTimeslot)
  }

  selectTimeslot(timeslot: any, term: any): void {
    // if (timeslot.is_disabled) return;
    this.selectedSlot = timeslot;
    this.isSlotSelected = true;
    console.log('timeslot termina', timeslot);
  }

  areAllSlotsDisabled(term: any): boolean {
    return term?.slots?.length > 0 && term.slots.every((s: any) => s.is_disabled === true);
  }
}
